import { z } from 'zod';
import { uuidSchema } from './common.schema';

// ─── Request Schemas ──────────────────────────────────────────────────────────

export const CreateUserLocationAssignmentSchema = z.object({
  user_id: uuidSchema,
  hospital_id: uuidSchema,
  location_id: uuidSchema,
  unit_id: uuidSchema,
});

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const UserLocationAssignmentSchema = z.object({
  id: uuidSchema,
  user_id: z.string(),
  hospital_id: z.string(),
  location_id: z.string(),
  location_name: z.string().nullable(),
  unit_id: z.string(),
  unit_name: z.string().nullable(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const UserLocationAssignmentResponseSchema = z.object({
  success: z.literal(true),
  data: UserLocationAssignmentSchema,
  meta: z.object({
    requestId: z.string(),
    timestamp: z.string(),
  }),
});

export const UserLocationAssignmentListResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(UserLocationAssignmentSchema),
  meta: z.object({
    requestId: z.string(),
    timestamp: z.string(),
  }),
});

// ─── Types ────────────────────────────────────────────────────────────────────

export type CreateUserLocationAssignment = z.infer<typeof CreateUserLocationAssignmentSchema>;
export type UserLocationAssignment = z.infer<typeof UserLocationAssignmentSchema>;
export type UserLocationAssignmentResponse = z.infer<typeof UserLocationAssignmentResponseSchema>;
